import {
    Checkbox, Card, Snackbar, Backdrop, Button, FormControl, Select, CardContent,
    CardHeader, Container, Grid, Dialog, IconButton, TextField,
} from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import Divider from '@material-ui/core/Divider';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { makeStyles } from '@material-ui/styles';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import Page from 'src/components/Page';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';
import SendIcon from '@material-ui/icons/Send';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import UploadFile from '../../components/UploadFileForApplication';
import Photo from '../../components/Photo';
import Alert from 'src/components/Alert';
import InfoIcon from '@mui/icons-material/Info';
import Tooltip from '@mui/material/Tooltip';

const DefaultConsumerChangeValue = {
    d: 0,
    CloseType: 0,
    ServiceType: '',
    CityLocation: '',
    ServiceLocation: '',
    Country: '',
    Town: '',
    PersonType: '',
    ServiceInfo: '',
    Devir: 0,
    Birlesme: 0,
    Subelesme: 0,
    Findeks: ''
};

const useStyles = makeStyles((theme) => ({
    root: {
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(3)
    },
    rootlist: {
        width: '100%',
        backgroundColor: theme.palette.background.paper,
        position: 'relative',
        overflow: 'auto',
        maxHeight: 550,
    },
    rootlistsag: {
        width: '100%',
        backgroundColor: theme.palette.background.paper,
        position: 'relative',
        overflow: 'auto',
        maxHeight: 500,
    },

    cardBolum: {
        maxHeight: 700,
        minHeight: 700,
        width: '100%'
    },
    table: {
        minWidth: 650,
    },
    content: {
        minHeight: 550,
    },
    chatSection: {
        width: '100%',
    },
    avatar: {
        cursor: 'pointer',
        width: 40,
        height: 40
    },
    headBG: {
        backgroundColor: '#e0e0e0'
    },
    borderRight500: {
        borderRight: '1px solid #e0e0e0'
    },
    messageArea: {
        overflowY: 'auto'
    },
    button: {
        margin: theme.spacing(1),
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
    actionsCCFile: {
        justifyContent: 'flex-end'
    }
}));
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;
function CloseService() {
    const classes = useStyles();
    const params = useParams();
    const [Loading, setLoading] = useState(false);
    const [uyari, setUyari] = useState(false);
    const [uyariTip, setUyariTip] = React.useState('default');
    const [uyariAciklama, setUyariAciklama] = useState('');
    const SessionUser = getUser();
    const [comment, setComment] = useState("")
    const [servisKapanisTip, setservisKapanisTip] = useState([]);
    const [servisKisi, setServisKisi] = useState([]);
    const [servisKonum, setServisKonum] = useState([]);
    const [servisLokasyonIl, setServisLokasyonIl] = useState([]);
    const [servisLokasyonIlce, setServisLokasyonIlce] = useState([]);
    const [servisLokasyonKonum, setServisLokasyonKonum] = useState([]);
    const [servisTip, setServisTip] = useState([]);
    const [birimler, setbirimler] = useState([]);
    const [subebirim, setSubeBirim] = useState([]);
    const [birlesenBirimler, setBirlesenBirimler] = useState([]);
    const [closeTypeValue, setCloseTypeValue] = useState(0);
    const [personType, setPersonType] = useState(0);
    const [location, setlocation] = useState(0);
    const [locationCity, setLocationCity] = useState(0);
    const [locationType, setLocationType] = useState(0);
    const [serviceType, setServiceType] = useState(0);
    const [adaySayisi, setAdaySayisi] = useState(1);
    const [adaySayisiDosyaAdet, setadaySayisiDosyaAdet] = useState([]);
    const [locationIlce, setLocationIlce] = useState(0);
    const [service, setService] = useState(0);
    const [subeler, setSubeler] = useState([]);
    const [subelesenBirim, setSubelesenBirim] = useState(0);
    const [ortaklasanBirim, setOrtaklasanBirim] = useState([]);
    const [fileList, setFileList] = React.useState([]);
    const [maxId, setMaxId] = useState(0);
    const [photoPopUp, setPhotoPopUp] = useState(false);
    const [formData, setFormdata] = useState(DefaultConsumerChangeValue);
    const [dosyaTipi, setDosyaTipi] = useState(1);
    const [fileTypeData, setFileTypeData] = React.useState([])
    const [uploadingFile, setUploadingFile] = useState([]);
    const [filesDataToSend, setFilesDataToSend] = useState([]);
    const [bolgeyeBagliSubeler, setBolgeyeBagliSubeler] = useState([]);

    const handleCloseType = (cityValue) => {
        const data = {
            ItemValue: SessionUser.TopServiceShopCode,
            ItemId: 1,
            cityValue: cityValue?.Id
        }
        const config = {
            headers: { 'Content-Type': 'application/json' }
        }
        axios.post('GetCatalogItemsForClose', data, config).then((response) => {
            if (response.data.length > 0) {
                const res = response.data[0]
                setLoading(false);
                setservisKapanisTip(res.KapanisTipi)
                setbirimler(res.BolgeyeBagliBirim)
                //res.BolgeyeBagliBirim'in Dsc'sinde "ŞUBE" kelimesi geçenleri bolgeyeBaliSubeler'e atıyoruz
                setBolgeyeBagliSubeler(res.BolgeyeBagliBirim.filter(item => item.Dsc.includes('ŞUBE')));
                setSubeBirim(res.SubeBirim)
                setMaxId(res.MaxId[0].Id)
            } else {
                setLoading(false);
            }
        }).catch(error => {
            setLoading(false);
        });
    }


    // function handleDocumentType(itemValue) {
    //     if (itemValue.Id == 5) {
    //         setDosyaTipi(2);
    //         handleFileType(2);
    //     } else {
    //         setDosyaTipi(1);
    //         handleFileType(1);
    //     }
    // }


    useEffect(() => {
        handleCloseType()
    }, [SessionUser.TopServiceShopCode, SessionUser.TechnicianId]);

    function servisKisiSayisi(value) {
        setAdaySayisi(value);
        var adet = value;
        var arr = [];
        for (var i = 0; i < adet; i++) {
            arr.push(i)
        }
        setadaySayisiDosyaAdet(arr);
    }

    const handleFileCloseType = (documentType) => {

        axios.get(`/GetFileCloseType/` + 1 + '/' + documentType, {
            responseType: 'arrayBuffer'
        })
            .then((response) => {
                const res = response.data;
                setFileTypeData(res);
            }).catch(error => {
            });
    }


    const handleApply = (event) => {
        if (closeTypeValue.Id == undefined || service.Id == undefined) {
            setUyariAciklama('Lütfen ilgili alanları kontrol ediniz!!.')
            setUyariTip('error')
            setUyari(true)
            return;
        }
        if (subebirim.length > 0 && subeler.length < 1) {
            setUyariAciklama('Merkezi kapatılan servisin şubesi açık olamaz. Lütfen ilgili şube/şubeleri seçiniz')
            setUyariTip('error')
            setUyari(true)
            return;
        }

        let differentTypeIds = [];
        fileTypeData.length > 0 && fileTypeData.reduce((acc, item) => {
            if (!uploadingFile.some(element => element.TypeId === item.ID) && (item.ZORUNLU === 1)) {
                differentTypeIds.push({
                    ID: item.ID, ACIKLAMA: item.ACIKLAMA
                });
            } return acc;
        }, []);
        if (differentTypeIds.length > 0) {
            setUyariAciklama(`Lütfen ${differentTypeIds[0].ACIKLAMA} dosyasını yükleyiniz!...`)
            setUyariTip('error')
            setUyari(true)
            return;
        }
        setLoading(true);
        const dataMessage = {
            CloseType: closeTypeValue.Id,
            Service: service.Id,
            ServiceInfo: comment,
            Subeler: subeler,
            UserId: "", //okta
            UploadFiles: uploadingFile.map((item) => ({
                ReceiptNumber: 0,
                AdaySayisiId: adaySayisi,
                FileName: item.FileName,
                FileType: item.FileType,
                FileData: item.FileData,
                TypeId: item.TypeId,
                CreateUser: "",
                OnOnay: 1,
                OpenClose: 2
            }))
        };
        const configMessage = {
            headers: { 'Content-Type': 'application/json' }
        }
        axios.post('/SetCloseApplication', dataMessage, configMessage).then(response => {
            let ResponseDataMessage = response.data[0];
            if (ResponseDataMessage.ErrorCode == "0") {
                setUyariAciklama(ResponseDataMessage.ErrorDescription);
                setUyari(true);
                setUyariTip("success")
                setCloseTypeValue(0);
                setComment('');
                setBirlesenBirimler([]);
                setServiceType(0);
                setLoading(false);
                ClearData();
            } else {
                setUyariTip("error");
                setUyariAciklama(ResponseDataMessage.ErrorDescription);
                setUyari(true);
                setLoading(false);
            }
        }).catch(error => {
            setUyariAciklama("Bir hata oluştu!..")
            setUyariTip("error");
            setUyari(true);
            setLoading(false);
        });
    }

    const uyariKapat = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setUyari(false);
    };


    function ClearData() {
        setCloseTypeValue(0);
        setServiceType(0);
        setLocationType(0);
        setLocationCity(0);
        setLocationType(0);
        setlocation(0);
        setLocationCity(0);
        setLocationIlce(0);
        setServiceType(0);
        setComment("");
        setService(0);
        setBirlesenBirimler([]);
        setOrtaklasanBirim([]);
        setSubeler([]);
        servisKisiSayisi(1);
        setMaxId(maxId + 2)
        setUploadingFile([]);
        setFileTypeData([]);
    }


    return (
        <Page className={classes.root}>
            <Backdrop className={classes.backdrop} open={Loading} >
                <CircularProgress color="inherit" />
            </Backdrop>
            <Snackbar open={uyari} autoHideDuration={10000} onClose={uyariKapat}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}>
                <Alert onClose={uyariKapat} variant={uyariTip} message={uyariAciklama}>
                </Alert>
            </Snackbar>
            <Container maxWidth="xl">
                <Card>
                    <CardHeader title="Servis Kapanış Talebi" subheader={'Id: ' + (maxId + 1)} />
                    <Divider />
                    <CardContent>
                        <Grid container spacing={1}>
                            <Grid item xs={12} sm={3} lg={2}>
                                <Autocomplete
                                    size="small"
                                    fullWidth
                                    disableClearable
                                    value={closeTypeValue}
                                    options={servisKapanisTip}
                                    getOptionLabel={(option) => (option.Dsc ? option.Dsc : '')}
                                    getOptionSelected={(option, value) => option.Id === value.Id}
                                    renderInput={(params) => <TextField {...params} label={('Kapanış Tipi')} variant="outlined" required />}
                                    onChange={(event, value) => {
                                        setCloseTypeValue(value);
                                        handleFileCloseType(value.Id);
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={3} lg={2}>
                                <Autocomplete
                                    size="small"
                                    fullWidth
                                    disableClearable
                                    value={service}
                                    options={closeTypeValue.Id === 4 ? bolgeyeBagliSubeler : birimler}
                                    getOptionLabel={(option) => (option.Dsc ? option.Dsc : '')}
                                    getOptionSelected={(option, value) => option.Id === value.Id}
                                    renderInput={(params) => <TextField {...params} label={('Servis')} variant="outlined" />}
                                    onChange={(event, value) => {
                                        setService(value);
                                        handleCloseType(value)
                                        setSubeler([])
                                    }}
                                />
                            </Grid>
                            {closeTypeValue.Id !== 4 ? (
                                <Grid item xs={12} sm={3} lg={2}>
                                    <Autocomplete
                                        multiple
                                        size="small"
                                        fullWidth
                                        limitTags={1}
                                        disableCloseOnSelect
                                        value={subeler}
                                        options={subebirim}
                                        getOptionLabel={(option) => (option.Dsc ? option.Dsc : '')}
                                        onChange={(event, value) => { setSubeler(value); }}
                                        renderOption={(option, { selected }) => (
                                            <React.Fragment>
                                                <Checkbox
                                                    icon={icon}
                                                    checkedIcon={checkedIcon}
                                                    style={{ marginRight: 8 }}
                                                    checked={selected}
                                                />
                                                {option.Dsc}
                                            </React.Fragment>
                                        )
                                        }
                                        renderInput={(params) =>
                                            <TextField {...params}
                                                label={('Servis Şubeleri')}
                                                variant="outlined" />}
                                    />
                                </Grid>) : null}
                            <Grid item xs={12} sm={3} lg={2}>
                                <TextField
                                    size="small"
                                    id="comment"
                                    value={comment}
                                    onChange={event =>
                                        setComment(event.target.value)}
                                    fullWidth
                                    label={'Servis Hakkında Bilgi'}
                                    variant="outlined"
                                    autoComplete='off'
                                />
                            </Grid>
                            <Grid item xs={1}>
                                <Tooltip title="Servisin neden kapandığına dair genel bilgilendirme (Servis sahibinin sağlık sorunu, iş gücü yetersizliği vb.)" arrow>
                                    <InfoIcon fontSize="large" style={{ marginTop: '0px', cursor: 'pointer' }} />
                                </Tooltip>
                            </Grid>
                        </Grid>
                        <Grid container spacing={1}>
                            <br />
                        </Grid>
                        <Divider />
                        <br />
                        {closeTypeValue.Id !== 2 ?
                            <UploadFile basvuruId={maxId + 1} documentType={fileTypeData} dosyaAdet={adaySayisi} documentTypeNumber={10}
                                openClose={2} uploadingFile={uploadingFile} setUploadingFile={setUploadingFile} setFilesDataToSend={setFilesDataToSend} /> : null}
                    </CardContent>
                    <Divider />
                    <Grid item xs={12} sm={6} lg={10}  >
                    </Grid>
                    <Grid item xs={12} sm={12} lg={12}  >
                        <Button
                            variant="contained"
                            color="secondary"
                            fullWidth
                            endIcon={<SendIcon />}
                            onClick={() => {
                                handleApply()
                            }}
                        >
                            ONAYA GÖNDER
                        </Button>
                    </Grid>
                    <Dialog
                        open={photoPopUp}
                        fullWidth={true}
                        maxWidth={'xl'}
                        onClose={() => setPhotoPopUp(false)}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <Grid container >
                            <Grid item xs={12} sm={12} lg={12}>
                                <Photo> </Photo>
                            </Grid>
                        </Grid>
                    </Dialog>
                </Card>
            </Container>
        </Page >
    );
}

export default CloseService;
